module.exports = __webpack_public_path__ + "img/login-qrcode.10615a03.png";